module.exports = __webpack_public_path__ + "img/welcome@2x.5c606f0e.png";